import satisfactionSurveyReducer from "./satisfactionSurveyReducer";

const satisfactionSurveyReducers = {
    satisfactionSurvey: satisfactionSurveyReducer
}

export default satisfactionSurveyReducers;